/**
 * Oratelier — client API formulaire réparation (Plan B — Site Write Projet A)
 * Création d'intervention = source de vérité. Email/WA = notification.
 * Ne pointe PAS vers projet-C (obsolète).
 */
(function (global) {
  'use strict';

  /**
   * URL Site Write déjà dans ce fichier (Segway Express validé — catalog_version 4).
   * Coller ce JS dans Assets suffit.
   * Si le Liquid définit un ancien ORA_CONFIG.apiUrl cassé, on le remplace (voir BAD_SITE_WRITE_IDS_).
   * Ne jamais mettre l’URL Atelier (?atelier=1&gate=…).
   */
  var SITE_WRITE_URL_OK_ =
    'https://script.google.com/macros/s/AKfycbzpVhN2K6RApX7ZDKIU9iUdW7SUhepFaGyjWatMlO0ThbA9zEuf6gQrfD7gv3vGjXLQ/exec';
  /* Anciens déploiements qui renvoient marques [] / page HTML */
  var BAD_SITE_WRITE_IDS_ = [
    'AKfycbx60J7O3M_jMs_5esR_ZS0-2OaGcfYRMnW15ZlLVab5sHgFbgrlwVx2ioNHoBbY2Od6'
  ];

  var ORA_DEFAULTS = {
    apiUrl: SITE_WRITE_URL_OK_,
    /* siteKey = barrière faible uniquement (visible dans le JS = pas un secret) */
    siteKey: '',
    whatsapp: '33743765114',
    trackingBase: 'https://oratelier.fr/pages/suivi-oratelier',
    formulaireVersion: 'v2',
    features: {
      useApi: true,
      emailNotify: false,
      express: true,
      photoUpload: false,
      liveAvailability: false,
      loanVehicle: true
    },
    storageKey: 'ora_repair_draft_v5',
    draftTtlMs: 12 * 60 * 60 * 1000
  };

  function normalizeSiteWriteUrl_(url) {
    var u = String(url || '').trim();
    if (!u) return '';
    u = u.replace(/\/macros\/u\/\d+\/s\//, '/macros/s/');
    u = u.split('?')[0].replace(/\/$/, '');
    if (u.indexOf('script.google.com/macros/s/') === -1) return '';
    if (u.indexOf('/exec') === -1) return '';
    for (var i = 0; i < BAD_SITE_WRITE_IDS_.length; i++) {
      if (u.indexOf(BAD_SITE_WRITE_IDS_[i]) !== -1) return '';
    }
    return u;
  }

  var ORA_CONFIG = {};
  var incoming = global.ORA_CONFIG || {};
  Object.keys(ORA_DEFAULTS).forEach(function (k) {
    ORA_CONFIG[k] = incoming[k] !== undefined ? incoming[k] : ORA_DEFAULTS[k];
  });
  if (incoming.features && typeof incoming.features === 'object') {
    ORA_CONFIG.features = {};
    Object.keys(ORA_DEFAULTS.features).forEach(function (fk) {
      ORA_CONFIG.features[fk] = incoming.features[fk] !== undefined
        ? incoming.features[fk]
        : ORA_DEFAULTS.features[fk];
    });
  }
  /* Toujours une URL Site Write propre ; ancien déploiement Liquid → défaut OK */
  ORA_CONFIG.apiUrl = normalizeSiteWriteUrl_(ORA_CONFIG.apiUrl) || ORA_DEFAULTS.apiUrl;
  global.ORA_CONFIG = ORA_CONFIG;

  function uuid() {
    try {
      if (global.crypto && crypto.randomUUID) return crypto.randomUUID();
    } catch (e) {}
    return 'ora-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function getOrCreateSubmissionId() {
    try {
      var k = 'ora_submission_id';
      var existing = sessionStorage.getItem(k);
      if (existing) return existing;
      var id = uuid();
      sessionStorage.setItem(k, id);
      return id;
    } catch (e) {
      return uuid();
    }
  }

  function clearSubmissionId() {
    try { sessionStorage.removeItem('ora_submission_id'); } catch (e) {}
  }

  function apiEnabled() {
    return !!(ORA_CONFIG.features && ORA_CONFIG.features.useApi && ORA_CONFIG.apiUrl);
  }

  /**
   * POST JSON en text/plain pour éviter le préflight CORS Apps Script.
   */
  function postCreate(payload) {
    var url = String(ORA_CONFIG.apiUrl || '').replace(/\/$/, '');
    if (!url) {
      return Promise.reject({ error_code: 'NO_API_URL', message: 'API non configurée.' });
    }
    var body = Object.assign({}, payload, {
      action: 'create_intervention',
      site_key: ORA_CONFIG.siteKey || undefined
    });
    return fetch(url, {
      method: 'POST',
      redirect: 'follow',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.text().then(function (text) {
        var data = null;
        try { data = JSON.parse(text); } catch (e) { data = null; }
        if (!data) {
          return {
            success: false,
            error_code: 'BAD_RESPONSE',
            message: 'Votre demande n’a pas encore pu être enregistrée.'
          };
        }
        return data;
      });
    });
  }

  function getConfig() {
    var url = String(ORA_CONFIG.apiUrl || '').replace(/\/$/, '');
    if (!url) return Promise.resolve(null);
    return fetch(url + '?action=config', { method: 'GET', redirect: 'follow' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function estimateZone(cp, adresse, ville) {
    var url = String(ORA_CONFIG.apiUrl || '').replace(/\/$/, '');
    if (!url || !cp) return Promise.resolve(null);
    var q = '?action=zone&cp=' + encodeURIComponent(cp);
    if (adresse) q += '&adresse=' + encodeURIComponent(adresse);
    if (ville) q += '&ville=' + encodeURIComponent(ville);
    return fetch(url + q, { method: 'GET', redirect: 'follow' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function normalizeExpressQuery_(s) {
    return String(s || '')
      .replace(/\u00a0/g, ' ')
      .replace(/[-_/]+/g, ' ')
      .replace(/\s+/g, ' ')
      .replace(/^\s+|\s+$/g, '');
  }

  /** Retire la marque du début du modèle si le client l’a collée deux fois. */
  function stripMarqueFromModele_(marque, modele) {
    var m = normalizeExpressQuery_(modele);
    var b = normalizeExpressQuery_(marque);
    if (!m || !b) return m;
    var re = new RegExp('^' + b.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s+', 'i');
    return m.replace(re, '').replace(/^\s+|\s+$/g, '') || m;
  }

  function estimateExpress(marque, modele, prestation, position, dimension) {
    var url = String(ORA_CONFIG.apiUrl || '').replace(/\/$/, '');
    if (!url) return Promise.resolve(null);
    var m = normalizeExpressQuery_(marque);
    var mod = stripMarqueFromModele_(m, modele);
    var q = '?action=express&marque=' + encodeURIComponent(m) +
      '&modele=' + encodeURIComponent(mod) +
      '&prestation=' + encodeURIComponent(normalizeExpressQuery_(prestation) || '');
    if (position) q += '&position=' + encodeURIComponent(normalizeExpressQuery_(position));
    if (dimension) q += '&dimension=' + encodeURIComponent(normalizeExpressQuery_(dimension));
    return fetch(url + q, { method: 'GET', redirect: 'follow' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function parseJsonSafe_(r) {
    return r.text().then(function (t) {
      var s = String(t || '').trim();
      if (!s || s.charAt(0) === '<') return null;
      try { return JSON.parse(s); } catch (e) { return null; }
    });
  }

  var expressCatalogMem_ = null;
  var expressCatalogInflight_ = null;
  var EXPRESS_CATALOG_LS_ = 'ora_ex_catalog_v1';

  function readExpressCatalogLocal_() {
    try {
      var raw = localStorage.getItem(EXPRESS_CATALOG_LS_);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.marques || !parsed.marques.length) return null;
      /* 7 jours max — invalidé aussi si catalog_version change côté API */
      if (parsed._savedAt && Date.now() - parsed._savedAt > 7 * 24 * 60 * 60 * 1000) return null;
      return parsed;
    } catch (e) { return null; }
  }

  function writeExpressCatalogLocal_(cat) {
    try {
      if (!cat || !cat.marques || !cat.marques.length) return;
      var copy = {
        success: true,
        catalog_version: cat.catalog_version,
        marques: cat.marques,
        prestations: cat.prestations || [],
        modeles_par_marque: cat.modeles_par_marque || {},
        _savedAt: Date.now()
      };
      localStorage.setItem(EXPRESS_CATALOG_LS_, JSON.stringify(copy));
    } catch (e) { /* ignore */ }
  }

  function acceptExpressCatalog_(r) {
    return !!(r && r.success !== false && r.marques && r.marques.length);
  }

  /** Ancien Site Write sans action express_catalog → express_marques (sans modèles). */
  function fetchExpressMarquesFallback_(url) {
    return fetch(url + '?action=express_marques', {
      method: 'GET',
      redirect: 'follow',
      cache: 'default'
    })
      .then(parseJsonSafe_)
      .then(function (m) {
        if (!acceptExpressCatalog_(m)) return null;
        return {
          success: true,
          catalog_version: m.catalog_version,
          marques: m.marques,
          prestations: m.prestations || [],
          modeles_par_marque: m.modeles_par_marque || {},
          /* Pas de catalogue modèles : getExpressModeles utilisera express_modeles */
          _marquesOnly: !(m.modeles_par_marque && Object.keys(m.modeles_par_marque).length)
        };
      })
      .catch(function () { return null; });
  }

  function storeCatalogMem_(cat, persist) {
    if (!cat) return cat;
    expressCatalogMem_ = cat;
    /* Ne pas persister un catalogue sans modèles (bloque le fallback express_modeles) */
    if (persist && !cat._marquesOnly) writeExpressCatalogLocal_(cat);
    return cat;
  }

  function getExpressCatalog(force) {
    if (!force && expressCatalogMem_ && expressCatalogMem_.marques && expressCatalogMem_.marques.length) {
      return Promise.resolve(expressCatalogMem_);
    }
    if (!force && expressCatalogInflight_) return expressCatalogInflight_;
    var url = String(ORA_CONFIG.apiUrl || '').replace(/\/$/, '');
    if (!url) return Promise.resolve(readExpressCatalogLocal_());

    expressCatalogInflight_ = fetch(url + '?action=express_catalog', {
      method: 'GET',
      redirect: 'follow',
      cache: 'default'
    })
      .then(parseJsonSafe_)
      .then(function (r) {
        if (acceptExpressCatalog_(r) && r.modeles_par_marque && Object.keys(r.modeles_par_marque).length) {
          expressCatalogInflight_ = null;
          return storeCatalogMem_(r, true);
        }
        if (acceptExpressCatalog_(r) && !r._marquesOnly) {
          /* Catalog OK même sans clés modèles (rare) — on garde et on laisse express_modeles */
          r._marquesOnly = !(r.modeles_par_marque && Object.keys(r.modeles_par_marque).length);
          expressCatalogInflight_ = null;
          return storeCatalogMem_(r, !r._marquesOnly);
        }
        return fetchExpressMarquesFallback_(url).then(function (fb) {
          expressCatalogInflight_ = null;
          if (fb) return storeCatalogMem_(fb, false);
          return expressCatalogMem_ || readExpressCatalogLocal_();
        });
      })
      .catch(function () {
        return fetchExpressMarquesFallback_(url).then(function (fb) {
          expressCatalogInflight_ = null;
          if (fb) return storeCatalogMem_(fb, false);
          return expressCatalogMem_ || readExpressCatalogLocal_();
        });
      });
    return expressCatalogInflight_;
  }

  function getExpressMarques() {
    var local = expressCatalogMem_ || readExpressCatalogLocal_();
    if (local && local.marques && local.marques.length) {
      /* Peindre tout de suite, rafraîchir en fond */
      getExpressCatalog(false);
      return Promise.resolve({
        success: true,
        catalog_version: local.catalog_version,
        marques: local.marques,
        prestations: local.prestations || []
      });
    }
    return getExpressCatalog(false).then(function (cat) {
      if (!cat) return null;
      return {
        success: true,
        catalog_version: cat.catalog_version,
        marques: cat.marques || [],
        prestations: cat.prestations || []
      };
    });
  }

  function getExpressModeles(marque, prestation) {
    var m = normalizeExpressQuery_(marque) || '';
    function fromCat_(cat) {
      if (!cat || cat._marquesOnly || !cat.modeles_par_marque) return null;
      if (!Object.keys(cat.modeles_par_marque).length) return null;
      var list = cat.modeles_par_marque[m] || cat.modeles_par_marque[marque] || [];
      if (!list.length) {
        var keys = Object.keys(cat.modeles_par_marque);
        for (var i = 0; i < keys.length; i++) {
          if (String(keys[i]).toLowerCase() === String(m).toLowerCase()) {
            list = cat.modeles_par_marque[keys[i]];
            break;
          }
        }
      }
      if (!list.length) return null;
      if (prestation) {
        var pn = String(prestation).toLowerCase();
        list = list.filter(function (item) {
          if (!item.prestations || !item.prestations.length) return true;
          return item.prestations.some(function (lab) {
            return String(lab).toLowerCase().indexOf(pn) !== -1 ||
              pn.indexOf(String(lab).toLowerCase()) !== -1;
          });
        });
      }
      if (!list.length) return null;
      return {
        success: true,
        catalog_version: cat.catalog_version,
        marque: m,
        modeles: list
      };
    }
    function fetchModelesApi_() {
      var url = String(ORA_CONFIG.apiUrl || '').replace(/\/$/, '');
      if (!url || !m) return Promise.resolve(null);
      var q = '?action=express_modeles&marque=' + encodeURIComponent(m);
      if (prestation) q += '&prestation=' + encodeURIComponent(normalizeExpressQuery_(prestation));
      return fetch(url + q, { method: 'GET', redirect: 'follow', cache: 'default' })
        .then(parseJsonSafe_)
        .catch(function () { return null; });
    }
    var local = expressCatalogMem_ || readExpressCatalogLocal_();
    var hit = fromCat_(local);
    if (hit && hit.modeles && hit.modeles.length) {
      getExpressCatalog(false);
      return Promise.resolve(hit);
    }
    return getExpressCatalog(false).then(function (cat) {
      var r = fromCat_(cat);
      if (r && r.modeles && r.modeles.length) return r;
      return fetchModelesApi_();
    });
  }

  function postWhatsappCta(reference, submissionId) {
    var url = String(ORA_CONFIG.apiUrl || '').replace(/\/$/, '');
    if (!url) return Promise.resolve(null);
    return fetch(url, {
      method: 'POST',
      redirect: 'follow',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify({
        action: 'whatsapp_cta',
        reference: reference || '',
        submission_id: submissionId || '',
        site_key: ORA_CONFIG.siteKey || undefined
      })
    }).then(function (r) { return r.json(); }).catch(function () { return null; });
  }

  function buildWaUrl(reference, answers, waNumber) {
    var num = String(waNumber || ORA_CONFIG.whatsapp || '33743765114').replace(/\D/g, '');
    var lines = [
      'Bonjour Oratelier,',
      '',
      'Je vous contacte concernant ma demande :',
      '',
      'Référence : ' + (reference || '—'),
      '',
      'Véhicule : ' + (answers.modele || answers.engin || '—'),
      'Panne : ' + (answers.probleme_main || answers.probleme || '—'),
      '',
      'Je vous joins les photos.'
    ];
    return 'https://wa.me/' + num + '?text=' + encodeURIComponent(lines.join('\n'));
  }

  function saveDraft(state) {
    try {
      var payload = {
        savedAt: Date.now(),
        state: state
      };
      localStorage.setItem(ORA_CONFIG.storageKey, JSON.stringify(payload));
    } catch (e) {}
  }

  function loadDraft() {
    try {
      var raw = localStorage.getItem(ORA_CONFIG.storageKey);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.savedAt) return null;
      if (Date.now() - parsed.savedAt > ORA_CONFIG.draftTtlMs) {
        localStorage.removeItem(ORA_CONFIG.storageKey);
        return null;
      }
      return parsed.state || null;
    } catch (e) {
      return null;
    }
  }

  function clearDraft() {
    try { localStorage.removeItem(ORA_CONFIG.storageKey); } catch (e) {}
  }

  global.OraRepairApi = {
    config: ORA_CONFIG,
    apiEnabled: apiEnabled,
    getOrCreateSubmissionId: getOrCreateSubmissionId,
    clearSubmissionId: clearSubmissionId,
    postCreate: postCreate,
    getConfig: getConfig,
    estimateZone: estimateZone,
    estimateExpress: estimateExpress,
    getExpressMarques: getExpressMarques,
    getExpressModeles: getExpressModeles,
    getExpressCatalog: getExpressCatalog,
    postWhatsappCta: postWhatsappCta,
    buildWaUrl: buildWaUrl,
    saveDraft: saveDraft,
    loadDraft: loadDraft,
    clearDraft: clearDraft,
    uuid: uuid
  };
})(typeof window !== 'undefined' ? window : this);
